/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { AnonymousConsentsEffects } from './anonymous-consents.effect';

export const effects: any[] = [AnonymousConsentsEffects];

export * from './anonymous-consents.effect';
